module.exports = __webpack_public_path__ + "media/configurations/X-O-e508b8c6.png";